import { IRoute } from "src/pages/Router/routes";
import { Icons } from "src/library/components/Icon/types";
import { dropAllowedHolidays } from "src/modules/shutdowns/utils/dropAllowedShutdowns";

import DropShutdownsPage from "./DropShutdownsPage";
import CreateEditDropShutdownPage from "./CreateEditDropShutdownPage";

const HolidayScreen: IRoute = {
  exact: true,
  path: "/shutdowns",
  pageComponent: DropShutdownsPage,
  title: "Holidays",
  roles: [ "customer" ],
  modules: [ "shutdown" ],
  menuType: "MAIN",
  privateRoute: true,
  icon: Icons.HOLIDAY,
  canView: ({ drops }) => dropAllowedHolidays(drops.drop)
};

const HolidaysSection: IRoute[] = [
  {
    exact: true,
    path: "/shutdowns/new",
    title: "Save Holiday",
    pageComponent: CreateEditDropShutdownPage,
    menuType: "EMPTY",
    privateRoute: true,
    roles: [ "customer" ],
    modules: [ "shutdown" ],
    parent: HolidayScreen,
    canView: ({ drops }) => dropAllowedHolidays(drops.drop)
  },
  {
    exact: true,
    path: "/shutdowns/:shutdownId",
    title: "Save Holiday",
    pageComponent: CreateEditDropShutdownPage,
    menuType: "EMPTY",
    privateRoute: true,
    roles: [ "customer" ],
    modules: [ "shutdown" ],
    parent: HolidayScreen,
    canView: ({ drops }) => dropAllowedHolidays(drops.drop)
  }
];

export default [ HolidayScreen, ...HolidaysSection ];
